<div class="container">
    <div class="row">
        <div class="col section-title-full" role="banner">
            <h1>
                <span i18n>Formulario de registro para extranjeros</span>
            </h1>
        </div>
    </div>
</div>

<main id="main-content" class="container">

    <div class="row align-items-center">
        <div class="col">
            <p class="text-destacado" i18n>Este formulario está orientado a la realización del trámite online. Es
                necesario disponer de un correo electrónico para poder completar el procedimiento.</p>
        </div>
    </div>

    <div class="mb-3">
        <h2 class="my-4" i18n>Tipo de solicitante</h2>
        <div class="card">
            <div class="row">
                <div class="col-12 mb-3">
                    <label for="tipo-solicitante" class="form-label">
                        <span i18n>Tipo de solicitante</span>: <span class="required" title="obligatorio">*</span>
                    </label>
                    <select id="tipo-solicitante" class="form-select" [(ngModel)]="applicant.applicantType"
                        (ngModelChange)="clearOtherForms()" required
                        [ngClass]="{'is-invalid': shouldShowError('applicantType', applicant.applicantType)}"
                        (blur)="markAsTouched('applicantType')">
                        <option value="" i18n>Seleccione tipo</option>
                        <option value="Individual" i18n>Individual</option>
                        <option value="Represented" i18n>Representado</option>
                        <option value="Company" i18n>Compañia</option>
                    </select>
                    <div *ngIf="shouldShowError('applicantType', applicant.applicantType)" class="invalid-feedback"
                        i18n>
                        Campo requerido
                    </div>
                </div>
            </div>
        </div>

        <!-- Sección para "Individual" -->
        <ng-container *ngIf="applicant.applicantType == 'Individual' && applicant.individual">
            <h2 class="my-4" i18n>Datos del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Nombre -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [(ngModel)]="applicant.individual.applicantIdentification.name"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('individualName', applicant.individual.applicantIdentification.name)}"
                            (blur)="markAsTouched('individualName')">
                        <div *ngIf="shouldShowError('individualName', applicant.individual.applicantIdentification.name)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Primer apellido -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="primer-apellido" class="form-label">
                            <span i18n>Primer apellido</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="primer-apellido"
                            [(ngModel)]="applicant.individual.applicantIdentification.firstSurname"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('individualFirstSurname', applicant.individual.applicantIdentification.firstSurname)}"
                            (blur)="markAsTouched('individualFirstSurname')">
                        <div *ngIf="shouldShowError('individualFirstSurname', applicant.individual.applicantIdentification.firstSurname)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Segundo apellido (opcional) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="segundo-apellido" class="form-label">
                            <span i18n>Segundo apellido</span>:
                        </label>
                        <input type="text" class="form-control" id="segundo-apellido"
                            [(ngModel)]="applicant.individual.applicantIdentification.secondSurname">
                    </div>

                    <!-- Fecha de nacimiento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="fecha-nacimiento" class="form-label">
                            <span i18n>Fecha de nacimiento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="date" class="form-control" id="fecha-nacimiento"
                            [(ngModel)]="applicant.individual.applicantIdentification.dateOfBirth.date"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('individualDateOfBirth', applicant.individual.applicantIdentification.dateOfBirth.date)}"
                            (blur)="markAsTouched('individualDateOfBirth')">
                        <div *ngIf="shouldShowError('individualDateOfBirth', applicant.individual.applicantIdentification.dateOfBirth.date)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Tipo de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.individual.applicantIdentification.documentType"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('individualDocumentType', applicant.individual.applicantIdentification.documentType)}"
                            (blur)="markAsTouched('individualDocumentType')">
                            <option value="" i18n>Seleccione una opción</option>
                            <option value="NIF" i18n>NIF</option>
                            <option value="NIE" i18n>NIE</option>
                            <option value="Passport" i18n>Pasaporte</option>
                            <option value="National ID" i18n>ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('individualDocumentType', applicant.individual.applicantIdentification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Número de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [(ngModel)]="applicant.individual.applicantIdentification.documentIdentification"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('individualDocumentIdentification', applicant.individual.applicantIdentification.documentIdentification)}"
                            (blur)="markAsTouched('individualDocumentIdentification')">
                        <div *ngIf="shouldShowError('individualDocumentIdentification', applicant.individual.applicantIdentification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Email -->
                    <div class="col-sm-6 mb-3">
                        <label for="email" class="form-label">
                            <span i18n>Email</span>: <span class="required" title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="email" required
                            [(ngModel)]="applicant.individual.applicantContact.email" (ngModelChange)="checkValid()"
                            [ngClass]="{'is-invalid': shouldShowError('individualEmail', applicant.individual.applicantContact.email)}"
                            (blur)="markAsTouched('individualEmail')">
                        <div *ngIf="shouldShowError('individualEmail', applicant.individual.applicantContact.email)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Confirmar email -->
                    <div class="col-sm-6 mb-3">
                        <label for="confirm-email" class="form-label">
                            <span i18n>Confirma email</span>: <span class="required" title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="confirm-email" required [(ngModel)]="confirmEmail"
                            (ngModelChange)="checkValid()"
                            [ngClass]="{'is-invalid': shouldShowError('confirmEmail', confirmEmail)}"
                            (blur)="markAsTouched('confirmEmail')">
                        <div *ngIf="shouldShowError('confirmEmail', confirmEmail)" class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de contacto del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Teléfono (opcional) -->
                    <div class="col-sm-6 mb-3">
                        <label for="telefono" class="form-label">
                            <span i18n>Teléfono de contacto</span>:
                        </label>
                        <input type="text" class="form-control" id="telefono"
                            [(ngModel)]="applicant.individual.applicantContact.phoneNumber">
                    </div>

                    <!-- País de residencia -->
                    <div class="col-sm-6 mb-3">
                        <label for="pais-residencia" class="form-label">
                            <span i18n>País de residencia</span>:
                        </label>
                        <select id="pais-residencia" class="form-select"
                            [(ngModel)]="applicant.individual.applicantContact.countryCode">
                            <option value="0" i18n>Selecciona un país</option>
                            @for (country of countries; track country.code) {
                            <option value="{{country.code}}">{{country.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Provincia -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="provincia" class="form-label">
                            <span i18n>Provincia</span>:
                        </label>
                        <select id="provincia" class="form-select"
                            [(ngModel)]="applicant.individual.applicantContact.province"
                            (ngModelChange)="loadMunicipalities()">
                            <option value="" i18n>Selecciona una provincia</option>
                            @for (province of provinces; track province.code) {
                            <option value="{{province.name}}">{{province.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Municipio -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="municipio" class="form-label">
                            <span i18n>Municipio</span>:
                        </label>
                        <select id="municipio" class="form-select"
                            [(ngModel)]="applicant.individual.applicantContact.municipality"
                            [disabled]="applicant.individual.applicantContact.province == ''">
                            <option value="" i18n>Selecciona un municipio</option>
                            @for (municipality of municipalities; track municipality.code) {
                            <option value="{{municipality.name}}">{{municipality.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Código postal -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                        <input type="text" class="form-control" id="cp"
                            [(ngModel)]="applicant.individual.applicantContact.postalCode">
                    </div>

                    <!-- Tipo de vía -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                        <select id="stret-type" class="form-select"
                            [(ngModel)]="applicant.individual.applicantContact.streetTypeCode">
                            <option value="" i18n>Selecciona un tipo de vía</option>
                            @for (strTyp of streetTypes; track strTyp.code) {
                            <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Nombre de vía -->
                    <div class="col-sm-6 col-xl-6 mb-3">
                        <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                        <input type="text" class="form-control" id="nombre-via"
                            [(ngModel)]="applicant.individual.applicantContact.streetName">
                    </div>

                    <!-- Número -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                        <input type="text" class="form-control" id="numero"
                            [(ngModel)]="applicant.individual.applicantContact.streetNumber">
                    </div>

                    <!-- Piso -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                        <input type="text" class="form-control" id="piso"
                            [(ngModel)]="applicant.individual.applicantContact.floor">
                    </div>

                    <!-- Puerta -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                        <input type="text" class="form-control" id="puerta"
                            [(ngModel)]="applicant.individual.applicantContact.door">
                    </div>

                    <!-- Escalera -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                        <input type="text" class="form-control" id="stairCase"
                            [(ngModel)]="applicant.individual.applicantContact.stairCase">
                    </div>

                    <!-- Bloque -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                        <input type="text" class="form-control" id="block"
                            [(ngModel)]="applicant.individual.applicantContact.block">
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Sección para "Represented" -->
        <ng-container *ngIf="applicant.applicantType == 'Represented' && applicant.represented">
            <h2 class="my-4" i18n>Datos del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Nombre -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [(ngModel)]="applicant.represented.applicantIdentification.name"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representedName', applicant.represented.applicantIdentification.name)}"
                            (blur)="markAsTouched('representedName')">
                        <div *ngIf="shouldShowError('representedName', applicant.represented.applicantIdentification.name)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Primer apellido -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="primer-apellido" class="form-label">
                            <span i18n>Primer apellido</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="primer-apellido"
                            [(ngModel)]="applicant.represented.applicantIdentification.firstSurname"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representedFirstSurname', applicant.represented.applicantIdentification.firstSurname)}"
                            (blur)="markAsTouched('representedFirstSurname')">
                        <div *ngIf="shouldShowError('representedFirstSurname', applicant.represented.applicantIdentification.firstSurname)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Segundo apellido (opcional) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="segundo-apellido" class="form-label">
                            <span i18n>Segundo apellido</span>:
                        </label>
                        <input type="text" class="form-control" id="segundo-apellido"
                            [(ngModel)]="applicant.represented.applicantIdentification.secondSurname">
                    </div>

                    <!-- Fecha de nacimiento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="fecha-nacimiento" class="form-label">
                            <span i18n>Fecha de nacimiento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="date" class="form-control" id="fecha-nacimiento"
                            [(ngModel)]="applicant.represented.applicantIdentification.dateOfBirth.date"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representedDateOfBirth', applicant.represented.applicantIdentification.dateOfBirth.date)}"
                            (blur)="markAsTouched('representedDateOfBirth')">
                        <div *ngIf="shouldShowError('representedDateOfBirth', applicant.represented.applicantIdentification.dateOfBirth.date)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Tipo de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.represented.applicantIdentification.documentType"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representedDocumentType', applicant.represented.applicantIdentification.documentType)}"
                            (blur)="markAsTouched('representedDocumentType')">
                            <option value="" i18n>Seleccione una opción</option>
                            <option value="NIF" i18n>NIF</option>
                            <option value="NIE" i18n>NIE</option>
                            <option value="Passport" i18n>Pasaporte</option>
                            <option value="National ID" i18n>ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('representedDocumentType', applicant.represented.applicantIdentification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Número de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [(ngModel)]="applicant.represented.applicantIdentification.documentIdentification"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representedDocumentIdentification', applicant.represented.applicantIdentification.documentIdentification)}"
                            (blur)="markAsTouched('representedDocumentIdentification')">
                        <div *ngIf="shouldShowError('representedDocumentIdentification', applicant.represented.applicantIdentification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de contacto del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Email -->
                    <div class="col-sm-6 mb-3">
                        <label for="email" class="form-label">
                            <span i18n>Email</span>: <span class="required" title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="email" required
                            [(ngModel)]="applicant.represented.applicantContact.email" (ngModelChange)="checkValid()"
                            [ngClass]="{'is-invalid': shouldShowError('representedEmail', applicant.represented.applicantContact.email)}"
                            (blur)="markAsTouched('representedEmail')">
                        <div *ngIf="shouldShowError('representedEmail', applicant.represented.applicantContact.email)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Confirmar email -->
                    <div class="col-sm-6 mb-3">
                        <label for="confirm-email" class="form-label">
                            <span i18n>Confirma email</span>: <span class="required" title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="confirm-email" required [(ngModel)]="confirmEmail"
                            (ngModelChange)="checkValid()"
                            [ngClass]="{'is-invalid': shouldShowError('representedConfirmEmail', confirmEmail)}"
                            (blur)="markAsTouched('representedConfirmEmail')">
                        <div *ngIf="shouldShowError('representedConfirmEmail', confirmEmail)" class="invalid-feedback"
                            i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos del representado</h2>
            <div class="card">
                <div class="row">
                    <!-- Relación con el representado -->
                    <div class="col-12 mb-3">
                        <label for="tipo-solicitante" class="form-label">
                            <span i18n>Relación con el representado</span>: <span class="required"
                                title="obligatorio">*</span>
                        </label>
                        <select id="tipo-solicitante" class="form-select"
                            [(ngModel)]="applicant.represented.relationship" (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representedRelationship', applicant.represented.relationship)}"
                            (blur)="markAsTouched('representedRelationship')">
                            <option value="" i18n>Seleccione tipo</option>
                            <option *ngFor="let r of relationships" [value]="r.name">{{r.name}}</option>
                        </select>
                        <div *ngIf="shouldShowError('representedRelationship', applicant.represented.relationship)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Nombre del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [(ngModel)]="applicant.represented.representativeIdentification.name"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representativeName', applicant.represented.representativeIdentification.name)}"
                            (blur)="markAsTouched('representativeName')">
                        <div *ngIf="shouldShowError('representativeName', applicant.represented.representativeIdentification.name)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Primer apellido del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="primer-apellido" class="form-label">
                            <span i18n>Primer apellido</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="primer-apellido"
                            [(ngModel)]="applicant.represented.representativeIdentification.firstSurname"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representativeFirstSurname', applicant.represented.representativeIdentification.firstSurname)}"
                            (blur)="markAsTouched('representativeFirstSurname')">
                        <div *ngIf="shouldShowError('representativeFirstSurname', applicant.represented.representativeIdentification.firstSurname)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Segundo apellido (opcional) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="segundo-apellido" class="form-label">
                            <span i18n>Segundo apellido</span>:
                        </label>
                        <input type="text" class="form-control" id="segundo-apellido"
                            [(ngModel)]="applicant.represented.representativeIdentification.secondSurname">
                    </div>

                    <!-- Fecha de nacimiento del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="fecha-nacimiento" class="form-label">
                            <span i18n>Fecha de nacimiento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="date" class="form-control" id="fecha-nacimiento"
                            [(ngModel)]="applicant.represented.representativeIdentification.dateOfBirth.date"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representativeDateOfBirth', applicant.represented.representativeIdentification.dateOfBirth.date)}"
                            (blur)="markAsTouched('representativeDateOfBirth')">
                        <div *ngIf="shouldShowError('representativeDateOfBirth', applicant.represented.representativeIdentification.dateOfBirth.date)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Tipo de documento del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.represented.representativeIdentification.documentType"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representativeDocumentType', applicant.represented.representativeIdentification.documentType)}"
                            (blur)="markAsTouched('representativeDocumentType')">
                            <option value="" i18n>Seleccione una opción</option>
                            <option value="NIF" i18n>NIF</option>
                            <option value="NIE" i18n>NIE</option>
                            <option value="Passport" i18n>Pasaporte</option>
                            <option value="National ID" i18n>ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('representativeDocumentType', applicant.represented.representativeIdentification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Número de documento del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [(ngModel)]="applicant.represented.representativeIdentification.documentIdentification"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('representativeDocumentIdentification', applicant.represented.representativeIdentification.documentIdentification)}"
                            (blur)="markAsTouched('representativeDocumentIdentification')">
                        <div *ngIf="shouldShowError('representativeDocumentIdentification', applicant.represented.representativeIdentification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de contacto del representado</h2>
            <div class="card">
                <div class="row">
                    <!-- Teléfono de contacto (opcional) -->
                    <div class="col-sm-6 mb-3">
                        <label for="telefono" class="form-label">
                            <span i18n>Teléfono de contacto</span>:
                        </label>
                        <input type="text" class="form-control" id="telefono"
                            [(ngModel)]="applicant.represented.applicantContact.phoneNumber">
                    </div>

                    <!-- País de residencia -->
                    <div class="col-sm-6 mb-3">
                        <label for="pais-residencia" class="form-label">
                            <span i18n>País de residencia</span>:
                        </label>
                        <select id="pais-residencia" class="form-select"
                            [(ngModel)]="applicant.represented.applicantContact.countryCode">
                            <option value="0" i18n>Selecciona un país</option>
                            @for (country of countries; track country.code) {
                            <option value="{{country.code}}">{{country.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Provincia -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="provincia" class="form-label">
                            <span i18n>Provincia</span>:
                        </label>
                        <select id="provincia" class="form-select"
                            [(ngModel)]="applicant.represented.applicantContact.province"
                            (ngModelChange)="loadMunicipalities()">
                            <option value="" i18n>Selecciona una provincia</option>
                            @for (province of provinces; track province.code) {
                            <option value="{{province.name}}">{{province.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Municipio -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="municipio" class="form-label">
                            <span i18n>Municipio</span>:
                        </label>
                        <select id="municipio" class="form-select"
                            [(ngModel)]="applicant.represented.applicantContact.municipality"
                            [disabled]="applicant.represented.applicantContact.province == ''">
                            <option value="" i18n>Selecciona un municipio</option>
                            @for (municipality of municipalities; track municipality.code) {
                            <option value="{{municipality.name}}">{{municipality.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Código postal -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                        <input type="text" class="form-control" id="cp"
                            [(ngModel)]="applicant.represented.applicantContact.postalCode">
                    </div>

                    <!-- Tipo de vía -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                        <select id="stret-type" class="form-select"
                            [(ngModel)]="applicant.represented.applicantContact.streetTypeCode">
                            <option value="" i18n>Selecciona un tipo de vía</option>
                            @for (strTyp of streetTypes; track strTyp.code) {
                            <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Nombre de vía -->
                    <div class="col-sm-6 col-xl-6 mb-3">
                        <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                        <input type="text" class="form-control" id="nombre-via"
                            [(ngModel)]="applicant.represented.applicantContact.streetName">
                    </div>

                    <!-- Número -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                        <input type="text" class="form-control" id="numero"
                            [(ngModel)]="applicant.represented.applicantContact.streetNumber">
                    </div>

                    <!-- Piso -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                        <input type="text" class="form-control" id="piso"
                            [(ngModel)]="applicant.represented.applicantContact.floor">
                    </div>

                    <!-- Puerta -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                        <input type="text" class="form-control" id="puerta"
                            [(ngModel)]="applicant.represented.applicantContact.door">
                    </div>

                    <!-- Escalera -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                        <input type="text" class="form-control" id="stairCase"
                            [(ngModel)]="applicant.represented.applicantContact.stairCase">
                    </div>

                    <!-- Bloque -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                        <input type="text" class="form-control" id="block"
                            [(ngModel)]="applicant.represented.applicantContact.block">
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Sección para "Company" -->
        <ng-container *ngIf="applicant.applicantType == 'Company' && applicant.company">
            <h2 class="my-4" i18n>Datos del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Nombre (empresa) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [(ngModel)]="applicant.company.applicantIdentification.name" (ngModelChange)="checkValid()"
                            required
                            [ngClass]="{'is-invalid': shouldShowError('companyName', applicant.company.applicantIdentification.name)}"
                            (blur)="markAsTouched('companyName')">
                        <div *ngIf="shouldShowError('companyName', applicant.company.applicantIdentification.name)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Primer apellido -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="primer-apellido" class="form-label">
                            <span i18n>Primer apellido</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="primer-apellido"
                            [(ngModel)]="applicant.company.applicantIdentification.firstSurname"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyFirstSurname', applicant.company.applicantIdentification.firstSurname)}"
                            (blur)="markAsTouched('companyFirstSurname')">
                        <div *ngIf="shouldShowError('companyFirstSurname', applicant.company.applicantIdentification.firstSurname)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Segundo apellido (opcional) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="segundo-apellido" class="form-label">
                            <span i18n>Segundo apellido</span>:
                        </label>
                        <input type="text" class="form-control" id="segundo-apellido"
                            [(ngModel)]="applicant.company.applicantIdentification.secondSurname">
                    </div>

                    <!-- Fecha de nacimiento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="fecha-nacimiento" class="form-label">
                            <span i18n>Fecha de nacimiento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="date" class="form-control" id="fecha-nacimiento"
                            [(ngModel)]="applicant.company.applicantIdentification.dateOfBirth.date"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyDateOfBirth', applicant.company.applicantIdentification.dateOfBirth.date)}"
                            (blur)="markAsTouched('companyDateOfBirth')">
                        <div *ngIf="shouldShowError('companyDateOfBirth', applicant.company.applicantIdentification.dateOfBirth.date)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Tipo de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.company.applicantIdentification.documentType"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyDocumentType', applicant.company.applicantIdentification.documentType)}"
                            (blur)="markAsTouched('companyDocumentType')">
                            <option value="" i18n>Seleccione una opción</option>
                            <option value="NIF" i18n>NIF</option>
                            <option value="NIE" i18n>NIE</option>
                            <option value="Passport" i18n>Pasaporte</option>
                            <option value="National ID" i18n>ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('companyDocumentType', applicant.company.applicantIdentification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Número de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [(ngModel)]="applicant.company.applicantIdentification.documentIdentification"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyDocumentIdentification', applicant.company.applicantIdentification.documentIdentification)}"
                            (blur)="markAsTouched('companyDocumentIdentification')">
                        <div *ngIf="shouldShowError('companyDocumentIdentification', applicant.company.applicantIdentification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de contacto del interesado</h2>
            <div class="card">
                <div class="row">
                    <!-- Email -->
                    <div class="col-sm-6 mb-3">
                        <label for="email" class="form-label">
                            <span i18n>Email</span>: <span class="required" title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="email" required
                            [(ngModel)]="applicant.company.applicantContact.email" (ngModelChange)="checkValid()"
                            required
                            [ngClass]="{'is-invalid': shouldShowError('companyEmail', applicant.company.applicantContact.email)}"
                            (blur)="markAsTouched('companyEmail')">
                        <div *ngIf="shouldShowError('companyEmail', applicant.company.applicantContact.email)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Confirmar email -->
                    <div class="col-sm-6 mb-3">
                        <label for="confirm-email" class="form-label">
                            <span i18n>Confirma email</span>: <span class="required" title="Obligatorio">*</span>
                        </label>
                        <input type="email" class="form-control" id="confirm-email" required [(ngModel)]="confirmEmail"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyConfirmEmail', confirmEmail)}"
                            (blur)="markAsTouched('companyConfirmEmail')">
                        <div *ngIf="shouldShowError('companyConfirmEmail', confirmEmail)" class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Teléfono (opcional) y demás campos de contacto se mantienen sin validación -->
                    <div class="col-sm-6 mb-3">
                        <label for="telefono" class="form-label">
                            <span i18n>Teléfono de contacto</span>:
                        </label>
                        <input type="text" class="form-control" id="telefono"
                            [(ngModel)]="applicant.company.applicantContact.phoneNumber">
                    </div>

                    <div class="col-sm-6 mb-3">
                        <label for="pais-residencia" class="form-label">
                            <span i18n>País de residencia</span>:
                        </label>
                        <select id="pais-residencia" class="form-select"
                            [(ngModel)]="applicant.company.applicantContact.countryCode">
                            <option value="0" i18n>Selecciona un país</option>
                            @for (country of countries; track country.code) {
                            <option value="{{country.code}}">{{country.name}}</option>
                            }
                        </select>
                    </div>

                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                        <select id="provincia" class="form-select"
                            [(ngModel)]="applicant.company.applicantContact.province"
                            (ngModelChange)="loadMunicipalities()">
                            <option value="" i18n>Selecciona una provincia</option>
                            @for (province of provinces; track province.code) {
                            <option value="{{province.name}}">{{province.name}}</option>
                            }
                        </select>
                    </div>

                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                        <select id="municipio" class="form-select"
                            [(ngModel)]="applicant.company.applicantContact.municipality"
                            [disabled]="applicant.company.applicantContact.province == ''">
                            <option value="" i18n>Selecciona un municipio</option>
                            @for (municipality of municipalities; track municipality.code) {
                            <option value="{{municipality.name}}">{{municipality.name}}</option>
                            }
                        </select>
                    </div>

                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                        <input type="text" class="form-control" id="cp"
                            [(ngModel)]="applicant.company.applicantContact.postalCode">
                    </div>

                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                        <select id="stret-type" class="form-select"
                            [(ngModel)]="applicant.company.applicantContact.streetTypeCode">
                            <option value="" i18n>Selecciona un tipo de vía</option>
                            @for (strTyp of streetTypes; track strTyp.code) {
                            <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                            }
                        </select>
                    </div>

                    <div class="col-sm-6 col-xl-6 mb-3">
                        <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                        <input type="text" class="form-control" id="nombre-via"
                            [(ngModel)]="applicant.company.applicantContact.streetName">
                    </div>

                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                        <input type="text" class="form-control" id="numero"
                            [(ngModel)]="applicant.company.applicantContact.streetNumber">
                    </div>

                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                        <input type="text" class="form-control" id="piso"
                            [(ngModel)]="applicant.company.applicantContact.floor">
                    </div>

                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                        <input type="text" class="form-control" id="puerta"
                            [(ngModel)]="applicant.company.applicantContact.door">
                    </div>

                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                        <input type="text" class="form-control" id="stairCase"
                            [(ngModel)]="applicant.company.applicantContact.stairCase">
                    </div>

                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                        <input type="text" class="form-control" id="block"
                            [(ngModel)]="applicant.company.applicantContact.block">
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de la empresa</h2>
            <div class="card">
                <div class="row" *ngIf="applicant.company">
                    <!-- Nombre de la empresa -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [(ngModel)]="applicant.company.identification.registeredName" (ngModelChange)="checkValid()"
                            required
                            [ngClass]="{'is-invalid': shouldShowError('companyRegisteredName', applicant.company.identification.registeredName)}"
                            (blur)="markAsTouched('companyRegisteredName')">
                        <div *ngIf="shouldShowError('companyRegisteredName', applicant.company.identification.registeredName)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                    <!-- Tipo de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.company.identification.documentType" (ngModelChange)="checkValid()"
                            required
                            [ngClass]="{'is-invalid': shouldShowError('companyIdentificationDocumentType', applicant.company.identification.documentType)}"
                            (blur)="markAsTouched('companyIdentificationDocumentType')">
                            <option value="" i18n>Seleccione una opción</option>
                            <option value="NIF" i18n>NIF</option>
                            <option value="NIE" i18n>NIE</option>
                            <option value="Passport" i18n>Pasaporte</option>
                            <option value="National ID" i18n>ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('companyIdentificationDocumentType', applicant.company.identification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                    <!-- Número de documento -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [(ngModel)]="applicant.company.identification.documentIdentification"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyIdentificationDocumentIdentification', applicant.company.identification.documentIdentification)}"
                            (blur)="markAsTouched('companyIdentificationDocumentIdentification')">
                        <div *ngIf="shouldShowError('companyIdentificationDocumentIdentification', applicant.company.identification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos del representado</h2>
            <div class="card">
                <div class="row" *ngIf="applicant.company">
                    <!-- Relación con el representado -->
                    <div class="col-12 mb-3">
                        <label for="tipo-solicitante" class="form-label">
                            <span i18n>Relación con el representado</span>: <span class="required"
                                title="obligatorio">*</span>
                        </label>
                        <select id="tipo-solicitante" class="form-select" [(ngModel)]="applicant.company.relationship"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyRelationship', applicant.company.relationship)}"
                            (blur)="markAsTouched('companyRelationship')">
                            <option value="" i18n>Seleccione tipo</option>
                            <option *ngFor="let r of relationships" [value]="r.name">{{r.name}}</option>
                        </select>
                        <div *ngIf="shouldShowError('companyRelationship', applicant.company.relationship)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Nombre del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="nombre" class="form-label">
                            <span i18n>Nombre</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="nombre"
                            [(ngModel)]="applicant.company.representativeIdentification.name"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyRepresentativeName', applicant.company.representativeIdentification.name)}"
                            (blur)="markAsTouched('companyRepresentativeName')">
                        <div *ngIf="shouldShowError('companyRepresentativeName', applicant.company.representativeIdentification.name)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Primer apellido del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="primer-apellido" class="form-label">
                            <span i18n>Primer apellido</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="primer-apellido"
                            [(ngModel)]="applicant.company.representativeIdentification.firstSurname"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyRepresentativeFirstSurname', applicant.company.representativeIdentification.firstSurname)}"
                            (blur)="markAsTouched('companyRepresentativeFirstSurname')">
                        <div *ngIf="shouldShowError('companyRepresentativeFirstSurname', applicant.company.representativeIdentification.firstSurname)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Segundo apellido (opcional) -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="segundo-apellido" class="form-label">
                            <span i18n>Segundo apellido</span>:
                        </label>
                        <input type="text" class="form-control" id="segundo-apellido"
                            [(ngModel)]="applicant.company.representativeIdentification.secondSurname">
                    </div>

                    <!-- Fecha de nacimiento del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="fecha-nacimiento" class="form-label">
                            <span i18n>Fecha de nacimiento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="date" class="form-control" id="fecha-nacimiento"
                            [(ngModel)]="applicant.company.representativeIdentification.dateOfBirth.date"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyRepresentativeDateOfBirth', applicant.company.representativeIdentification.dateOfBirth.date)}"
                            (blur)="markAsTouched('companyRepresentativeDateOfBirth')">
                        <div *ngIf="shouldShowError('companyRepresentativeDateOfBirth', applicant.company.representativeIdentification.dateOfBirth.date)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Tipo de documento del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="tipo-documento" class="form-label">
                            <span i18n>Tipo de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <select id="tipo-documento" class="form-select"
                            [(ngModel)]="applicant.company.representativeIdentification.documentType"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyRepresentativeDocumentType', applicant.company.representativeIdentification.documentType)}"
                            (blur)="markAsTouched('companyRepresentativeDocumentType')">
                            <option value="" i18n>Seleccione una opción</option>
                            <option value="NIF" i18n>NIF</option>
                            <option value="NIE" i18n>NIE</option>
                            <option value="Passport" i18n>Pasaporte</option>
                            <option value="National ID" i18n>ID nacional</option>
                        </select>
                        <div *ngIf="shouldShowError('companyRepresentativeDocumentType', applicant.company.representativeIdentification.documentType)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>

                    <!-- Número de documento del representante -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="firstname" class="form-label">
                            <span i18n>Numéro de documento</span>: <span class="required" title="obligatorio">*</span>
                        </label>
                        <input type="text" class="form-control" id="firstname"
                            [(ngModel)]="applicant.company.representativeIdentification.documentIdentification"
                            (ngModelChange)="checkValid()" required
                            [ngClass]="{'is-invalid': shouldShowError('companyRepresentativeDocumentIdentification', applicant.company.representativeIdentification.documentIdentification)}"
                            (blur)="markAsTouched('companyRepresentativeDocumentIdentification')">
                        <div *ngIf="shouldShowError('companyRepresentativeDocumentIdentification', applicant.company.representativeIdentification.documentIdentification)"
                            class="invalid-feedback" i18n>
                            Campo requerido
                        </div>
                    </div>
                </div>
            </div>

            <h2 class="my-4" i18n>Datos de contacto del representado</h2>
            <div class="card">
                <div class="row" *ngIf="applicant.company">
                    <!-- Teléfono de contacto (opcional) -->
                    <div class="col-sm-6 mb-3">
                        <label for="telefono" class="form-label">
                            <span i18n>Teléfono de contacto</span>:
                        </label>
                        <input type="text" class="form-control" id="telefono"
                            [(ngModel)]="applicant.company.representativeContact.phoneNumber">
                    </div>

                    <!-- País de residencia -->
                    <div class="col-sm-6 mb-3">
                        <label for="pais-residencia" class="form-label">
                            <span i18n>País de residencia</span>:
                        </label>
                        <select id="pais-residencia" class="form-select"
                            [(ngModel)]="applicant.company.representativeContact.countryCode">
                            <option value="0" i18n>Selecciona un país</option>
                            @for (country of countries; track country.code) {
                            <option value="{{country.code}}">{{country.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Provincia -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="provincia" class="form-label"><span i18n>Provincia</span>:</label>
                        <select id="provincia" class="form-select"
                            [(ngModel)]="applicant.company.representativeContact.province"
                            (ngModelChange)="loadMunicipalities()">
                            <option value="" i18n>Selecciona una provincia</option>
                            @for (province of provinces; track province.code) {
                            <option value="{{province.name}}">{{province.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Municipio -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="municipio" class="form-label"><span i18n>Municipio</span>:</label>
                        <select id="municipio" class="form-select"
                            [(ngModel)]="applicant.company.representativeContact.municipality"
                            [disabled]="applicant.company.representativeContact.province == ''">
                            <option value="" i18n>Selecciona un municipio</option>
                            @for (municipality of municipalities; track municipality.code) {
                            <option value="{{municipality.name}}">{{municipality.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Código postal -->
                    <div class="col-sm-6 col-xl-4 mb-3">
                        <label for="cp" class="form-label"><span i18n>Código postal</span>:</label>
                        <input type="text" class="form-control" id="cp"
                            [(ngModel)]="applicant.company.representativeContact.postalCode">
                    </div>

                    <!-- Tipo de vía -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="stret-type" class="form-label"><span i18n>Tipo de vía</span>:</label>
                        <select id="stret-type" class="form-select"
                            [(ngModel)]="applicant.company.representativeContact.streetTypeCode">
                            <option value="" i18n>Selecciona un tipo de vía</option>
                            @for (strTyp of streetTypes; track strTyp.code) {
                            <option value="{{strTyp.code}}">{{strTyp.name}}</option>
                            }
                        </select>
                    </div>

                    <!-- Nombre de vía -->
                    <div class="col-sm-6 col-xl-6 mb-3">
                        <label for="nombre-via" class="form-label"><span i18n>Nombre de vía</span>:</label>
                        <input type="text" class="form-control" id="nombre-via"
                            [(ngModel)]="applicant.company.representativeContact.streetName">
                    </div>

                    <!-- Número -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="numero" class="form-label"><span i18n>Número</span>:</label>
                        <input type="text" class="form-control" id="numero"
                            [(ngModel)]="applicant.company.representativeContact.streetNumber">
                    </div>

                    <!-- Piso -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="piso" class="form-label"><span i18n>Piso</span>:</label>
                        <input type="text" class="form-control" id="piso"
                            [(ngModel)]="applicant.company.representativeContact.floor">
                    </div>

                    <!-- Puerta -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="puerta" class="form-label"><span i18n>Puerta</span>:</label>
                        <input type="text" class="form-control" id="puerta"
                            [(ngModel)]="applicant.company.representativeContact.door">
                    </div>

                    <!-- Escalera -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="stairCase" class="form-label"><span i18n>Escalera</span>:</label>
                        <input type="text" class="form-control" id="stairCase"
                            [(ngModel)]="applicant.company.representativeContact.stairCase">
                    </div>

                    <!-- Bloque -->
                    <div class="col-sm-6 col-xl-3 mb-3">
                        <label for="block" class="form-label"><span i18n>Bloque</span>:</label>
                        <input type="text" class="form-control" id="block"
                            [(ngModel)]="applicant.company.representativeContact.block">
                    </div>
                </div>
            </div>
        </ng-container>

        <h2 class="my-4" *ngIf="applicant.applicantType" i18n>Datos de autenticación</h2>
        <div class="card" *ngIf="applicant.applicantType">
            <div class="row">
                <div class="col-sm-6 col-md-4">
                    <label for="username" class="form-label">
                        <span i18n>Usuario</span>: <span class="required" title="obligatorio">*</span>
                    </label>
                    <input type="text" class="form-control" id="username" *ngIf="applicant.individual"
                        [(ngModel)]="applicant.individual.applicantIdentification.documentIdentification" disabled>
                    <input type="text" class="form-control" id="username" *ngIf="applicant.represented"
                        [(ngModel)]="applicant.represented.applicantIdentification.documentIdentification" disabled>
                    <input type="text" class="form-control" id="username" *ngIf="applicant.company"
                        [(ngModel)]="applicant.company.applicantIdentification.documentIdentification" disabled>
                </div>

                <div class="col-sm-6 col-md-4">
                    <label for="password" class="form-label">
                        <span i18n>Contraseña</span>: <span class="required" title="obligatorio">*</span>
                    </label>
                    <input type="password" class="form-control" id="password" [(ngModel)]="password"
                        (ngModelChange)="checkValid()" required
                        [ngClass]="{'is-invalid': shouldShowError('password', password)}"
                        (blur)="markAsTouched('password')">
                    <div *ngIf="shouldShowError('password', password)" class="invalid-feedback" i18n>
                        Campo requerido
                    </div>
                </div>

                <div class="col-sm-6 col-md-4">
                    <label for="password" class="form-label">
                        <span i18n>Repetir Contraseña</span>: <span class="required" title="obligatorio">*</span>
                    </label>
                    <input type="password" class="form-control" id="password" [(ngModel)]="password2"
                        (ngModelChange)="checkValid()" required
                        [ngClass]="{'is-invalid': shouldShowError('confirmPassword', password2)}"
                        (blur)="markAsTouched('confirmPassword')">
                    <div *ngIf="shouldShowError('confirmPassword', password2)" class="invalid-feedback" i18n>
                        Campo requerido
                    </div>
                </div>
                <small class="col-12 mb-3 small-text" i18n>
                    * La contraseña debe tener entre 8 y 30 caracteres, e incluir números, símbolos, mayúsculas y
                    minúsculas.
                </small>
            </div>
        </div>

        <h2 class="my-4" *ngIf="newVehicle" i18n>Datos del vehículo</h2>
        <div class="card" *ngIf="newVehicle">
            <div class="row">
                <div class="col-md-4 mb-3">
                    <label for="plate" class="form-label"><span i18n>Matrícula</span>: <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control" id="plate" [(ngModel)]="newVehicle.vehiclePlate"
                        (ngModelChange)="checkValid()" required
                        [ngClass]="{'is-invalid': shouldShowError('plate', newVehicle.vehiclePlate)}"
                        (blur)="markAsTouched('plate')">
                    <div *ngIf="shouldShowError('plate', newVehicle.vehiclePlate)" class="invalid-feedback" i18n>
                        Campo requerido
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="alias" class="form-label"><span i18n>Alias</span>:</label>
                    <input type="text" class="form-control" id="alias" [(ngModel)]="newVehicle.vehicleAlias">
                </div>
                <div class="col-md-4 mb-3">
                    <label for="year" class="form-label"><span i18n>Año de primera matriculación</span>: <span
                            class="required">*</span>
                    </label>
                    <input type="text" class="form-control" id="year" [(ngModel)]="newException.type_foreign!.year"
                        (ngModelChange)="checkValid()" required
                        [ngClass]="{'is-invalid': shouldShowError('year', newException.type_foreign!.year)}"
                        (blur)="markAsTouched('year')">
                    <div *ngIf="shouldShowError('year', newException.type_foreign!.year)" class="invalid-feedback" i18n>
                        Campo requerido
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="category" class="form-label"><span i18n>Categoria de vehículo</span>: <span
                            class="required">*</span>
                    </label>
                    <select class="form-select" id="category"
                        [(ngModel)]="newException.type_foreign!.classification.code" (ngModelChange)="checkValid()"
                        required
                        [ngClass]="{'is-invalid': shouldShowError('category', newException.type_foreign!.classification.code)}"
                        (blur)="markAsTouched('category')">
                        <option value="" i18n>Selecciona una opción</option>
                        <option *ngFor="let category of classifications" [value]="category.code">{{category.name}}
                        </option>
                    </select>
                    <div *ngIf="shouldShowError('category', newException.type_foreign!.classification.code)"
                        class="invalid-feedback" i18n>
                        Campo requerido
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="fuel" class="form-label"><span i18n>Tipo de combustible</span>: <span
                            class="required">*</span>
                    </label>
                    <select class="form-select" id="fuel" [(ngModel)]="newException.type_foreign!.fuel.code"
                        (ngModelChange)="checkValid()" required
                        [ngClass]="{'is-invalid': shouldShowError('fuel', newException.type_foreign!.fuel.code)}"
                        (blur)="markAsTouched('fuel')">
                        <option value="" i18n>Selecciona una opción</option>
                        <option *ngFor="let fuel of fuels" [value]="fuel.code">{{fuel.name}}</option>
                    </select>
                    <div *ngIf="shouldShowError('fuel', newException.type_foreign!.fuel.code)" class="invalid-feedback"
                        i18n>
                        Campo requerido
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="pais-matriculacion" class="form-label">
                        <span i18n>País de matriculación</span>: <span class="required">*</span>
                    </label>
                    <select id="pais-matriculacion" class="form-select" [(ngModel)]="newVehicle.vehicleCountryCode"
                        (ngModelChange)="checkValid()" required
                        [ngClass]="{'is-invalid': shouldShowError('country', newVehicle.vehicleCountryCode)}"
                        (blur)="markAsTouched('country')">
                        <option value="0" i18n>Selecciona un país</option>
                        @for (country of countries; track country.code) {
                        <option value="{{country.code}}">{{country.name}}</option>
                        }
                    </select>
                    <div *ngIf="shouldShowError('country', newVehicle.vehicleCountryCode)" class="invalid-feedback"
                        i18n>
                        Campo requerido
                    </div>
                </div>
            </div>
        </div>

        <h2 class="my-4" *ngIf="newException.type.code" i18n>Datos de la solictud</h2>
        <div class="card">
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="vehicleType" class="form-label"><span i18n>Tipo de autorización que quiere
                            solicitar</span>:</label>
                    <select id="vehicleType" class="form-select" [(ngModel)]="newException.type.code" disabled>
                        <option value="">-----</option>
                        @for (vehicleType of vehiclesTypes; track vehicleType) {
                        <option value="{{vehicleType.code}}">{{vehicleType.name}}</option>
                        }
                    </select>
                </div>

                <div class="col-md-6 mb-3">
                    <label for="poblation" class="form-label">
                        <span i18n>¿Cuál es el municipio al que accederá por primera vez?</span>
                    </label>
                    <select id="poblation" class="form-select" [(ngModel)]="newException.municipality">
                        <option value="">-----</option>
                        @for (municipality of municipalities; track municipality) {
                        <option value="{{municipality.name}}">
                            {{municipality.code}}</option>
                        }
                    </select>
                </div>
                <div class="col-12 mb-3">
                    <p class="text-secondary text-center"><i class="bi bi-info-circle-fill"></i>
                        <span i18n>Esta autorización permitirá acceder, circular y estacionar al vehículo por las zonas
                            de bajas emisiones de los municipios de este <a routerLink="/town-halls">listado</a>.</span>
                    </p>
                </div>
            </div>
        </div>

        <h2 class="my-4" *ngIf="newException.type.code" i18n>Ficheros</h2>
        <div class="card" *ngIf="newException.type.code">
            <div class="row">
                <div class="col-12 mb-3">
                    <div i18n>
                        En el caso de vehículos que cumplen requisitos ambientales, debe adjuntarse la documentación del
                        vehículo donde conste el titular, la matrícula, la categoría de homologación, el tipo de
                        combustible y el nivel Euro. Si no se dispone de documentación oficial donde conste esta
                        información, debe acreditarse que se cumplen los niveles permitidos de emisiones de NOx y
                        partículas equivalentes mediante un documento emitido por el fabricante del vehículo (en
                        catalán, castellano, inglés o francés).
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <label for="formFileMultiple" class="form-label"><span i18n>Ficheros</span>:</label>
                    <div class="row mb-1">
                        <div class="col-10">
                            <app-custom-input-file (onFileSelected)="loadFile($event)"></app-custom-input-file>
                        </div>
                    </div>
                    <small i18n>Tamaño de fichero máximo de 5MB</small>
                </div>
            </div>
        </div>

        <div class="my-4" i18n>Protección de datos</div>
        <div class="mb-3 check-legal">
            <input class="form-check-input" type="checkbox" [(ngModel)]="applicant.flags!.veracity" id="data-treatment">
            <label for="data-treatment" class="ml-3"><span i18n>El firmante responde personalmente sobre la veracidad de
                    los datos manifestados y acepta y es consciente de que, en caso de comprobarse la falsedad de los
                    datos expuestos en la solicitud, perderá cualquier derecho al servicio.</span></label>
        </div>
        <div class="mb-3 check-legal">
            <input class="form-check-input" type="checkbox" [(ngModel)]="applicant.flags!.privacity" id="privacy">
            <label for="privacy" class="ml-3"><span i18n>Acepto la política de privacidad, para mas información haga
                    clic </span><a routerLink="/privacy" target="_blank" i18n>aquí</a>.</label>
        </div>
        <div class="check-legal my-4">
            <input class="form-check-input" type="checkbox" [(ngModel)]="applicant.flags!.email" id="sendEmail"
                (ngModelChange)="checkValid()" required>
            <label class="form-check-label ml-3" for="sendEmail" i18n>Acepto recibir comunicaciones por email.</label>
        </div>
        <div class="check-legal mb-3">
            <small i18n>En cumplimiento de lo dispuesto en la normativa de protección de datos vigente, se le informa
                que en función de la ZBE en la que haya presentado la documentación, las datos facilitados serán
                tratados por el municipio correspondiente de este listado de <a
                    routerLink="/town-halls">ayuntamientos</a> con la finalidad de tramitar su solicitud. Puede ejercer
                sus derechos y obtener más información consultando la Política de Privacidad.</small>
        </div>

        <div class="form-check my-4" *ngIf="!isValid">
            <span class="required" title="Obligatorio">*</span><small class="text-danger" i18n>Por favor, rellene todos
                los campos obligatorios.</small>
        </div>

        <button type="button" class="btn btn-secondary" i18n (click)="createApplicant()">Enviar</button>
    </div>
</main>